import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  InterfaceLanguageCode,
  INTERFACE_LANGUAGES,
  AVAILABLE_INTERFACE_LANGUAGES,
  DEFAULT_INTERFACE_LANGUAGE,
  isInterfaceLanguageAvailable,
  saveInterfaceLanguage,
} from '../constants/interfaceLanguages';

export function useInterfaceLanguage() {
  const { i18n } = useTranslation();
  const language: InterfaceLanguageCode = isInterfaceLanguageAvailable(i18n.language)
    ? (i18n.language as InterfaceLanguageCode)
    : DEFAULT_INTERFACE_LANGUAGE;

  const setLanguage = useCallback((code: InterfaceLanguageCode) => {
    i18n.changeLanguage(code);
    saveInterfaceLanguage(code);
  }, [i18n]);

  return {
    language,
    setLanguage,
    availableLanguages: AVAILABLE_INTERFACE_LANGUAGES.map((c) => INTERFACE_LANGUAGES[c]),
  };
}
